/** The board frame's chrome. */
export default {
  kindPill: "Board",
  loadingBoard: "Loading board",
  loadingBoardEllipsis: "Loading board…",
  noColumns: "No columns yet",
  noCards: "No cards",
} as const;
